// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const ApkLoanKKBFinancial2Service = {};

ApkLoanKKBFinancial2Service.getAddService = function (
  data
) {
  var dataIndex = data.pageIndex || 0;
  var decrementIndex = dataIndex === 0 ? dataIndex : dataIndex - 1;
  return lossClient({
    url:
      "/ApkLoanKKBFinancial2/getAdd?pageSize=" +
      data.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&prospectid=" +
      data?.prospectid,
    method: "get",
  });
};

ApkLoanKKBFinancial2Service.nettInterestService = function (data) {
  return lossClient({
    url: "/ApkLoanKKBFinancial2/nettinterest",
    method: "post",
    data: data,
  });
};


ApkLoanKKBFinancial2Service.postAddService = function (data) {
  return lossClient({
    url: "/ApkLoanKKBFinancial2/add",
    method: "post",
    data: data,
  });
};

 

export default ApkLoanKKBFinancial2Service;
